<template>
 <div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="指派" name="first">
          <assign :warehouseList="warehouseList" ref=bidding v-if="activeName=='first'"></assign>
        </el-tab-pane>
        <el-tab-pane label="竞价" name="two">
          <bidding :warehouseList="warehouseList" ref=bidding v-if="activeName=='two'"></bidding>
        </el-tab-pane>
        <el-tab-pane label="抢单" name="three">
          <grabOrders :warehouseList="warehouseList" ref=bidding v-if="activeName=='three'"></grabOrders>
        </el-tab-pane>

      </el-tabs>
 </div>
</template>

<script>
import bidding from '@/views/soc-stock-cosco/searchCarJY/bidding.vue'
import grabOrders from '@/views/soc-stock-cosco/searchCarJY/grabOrders.vue'
import assign from '@/views/soc-stock-cosco/searchCarJY/assign.vue'
import { getDictionaryAll, getOrganizationNameList, selectCommonDictionary } from '@/api/soc-stock-cosco'
import { getAttributeA } from '@/utils/getButton'
export default {
  components: {
    bidding, grabOrders, assign
  },
  data () {
    return {
      activeName: 'first',
      productTypes: [],
      warehouseList: [],
      oneCustomerTaxId: localStorage.getItem('tenantTaxpayerNumber'),
      warehouse: null
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    handleClick () {

    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
  width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
/deep/.el-tabs__item{
  padding-left: 10px!important;
}
// /deep/.el-tabs__active-bar{
//   padding: 0 10px;
//   margin-left: -10px;
// }
</style>
